define(["jquery","rivets","nouislider"],function($,rivets,nouislider){
	rivets.binders.nouislider={
		publishes:true,
		bind: function(el) {
			this.callback = function(type) {
				if (type=="update"){
					this.skipRoutine=true;
					this.publish();
					this.skipRoutine=false;
				}
				var event = document.createEvent("Event");
				event.initEvent(type,true,true);
				el.dispatchEvent(event);
			}.bind(this);

			var opts={
				min:0,
				max:100,
				step:1
			};
			var str=el.getAttribute("data-nouislider-opts");
			if (str){
				opts=$.extend(opts,JSON.parse(str));
			}

			this.slider=nouislider.create(el,{
				start:[this.observer.value()],
				range:{
					min:opts.min,
					max:opts.max,
				},
				step:opts.step
			});
			el.noUiSlider.on("update",this.callback.bind(this,"update"));
			el.noUiSlider.on("end",this.callback.bind(this,"end"));
			el.noUiSlider.on("start",this.callback.bind(this,"start"));
			el.noUiSlider.on("change",this.callback.bind(this,"change"));

			console.info(this.slider)
		},

		unbind: function(el) {
			if (el.noUiSlider){
				el.noUiSlider.off('update', this.callback);
				el.noUiSlider.off("end",this.callback);
				el.noUiSlider.off("start",this.callback);
				el.noUiSlider.off("change",this.callback);
				el.noUiSlider.destroy();
			}
		},
		getValue:function(el){
			return parseFloat(el.noUiSlider.get());
		},

		routine: function(el, value) {
			if (!this.skipRoutine)
				el.noUiSlider.set(value);
		}
	};

});
